import { render, staticRenderFns } from "./EventDiscountForm.vue?vue&type=template&id=d4f46aa6"
import script from "./EventDiscountForm.vue?vue&type=script&lang=js"
export * from "./EventDiscountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports